import React from "react";
import { H2, H3, P, Figure } from "../../../components/Newsletter/prose";
import GameSection from "../../../components/Newsletter/GameSection";
import { GAMES } from "../games";

// 2026년 9월, 응원해 주시는 분들께 남은 한 해의 계획을 전하는 글.
// 본문 문장은 원고(Notion) 그대로다. 게임별 이야기는 GameSection 으로 묶는다 —
// 게임마다 화면을 가로지르는 색 띠가 되어 어디서 이야기가 넘어가는지 보인다.

const IMG = "/newsletter/2026-09-roadmap";

export const meta = {
  slug: "roadmap-autumn-2026",
  lang: "ko",
  date: "2026-09-15",
  category: "company",
  title: "2026년 남은 시간, 바삭한소프트가 준비하고 있는 것들",
  author: "바삭한소프트",
  cover: `${IMG}/cover.png`,
  thumbnail: `${IMG}/thumb.jpg`,
};

export default function Body() {
  return (
    <>
      <P>안녕하세요. 바삭한소프트입니다.</P>

      <P>2026년이 벌써 약 4개월밖에 남지 않았는데요.</P>

      <P>
        지난 8개월간의 여정은 저희 바삭한소프트에게 많은 도전과 교훈을 주는
        시간들이었습니다.
      </P>

      <P>
        바삭한소프트를 아껴주시는 많은 팬분들께서 저희 게임을 사랑해주시고 진심어린
        의견과 응원을 보내주신 덕분에 지금의 바삭한소프트가 있다고 생각합니다.
      </P>

      <P>
        늘 발전하는 바삭한소프트가 되겠음을 약속드리며, 많은 관심에 항상 감사하다는 말씀
        전합니다.
      </P>

      <P>
        현재 바삭한소프트는 여러분이 저희 게임에 쏟아주신 애정과 노력이 재미로 보답받을 수
        있도록 다양한 방면에서 재투자를 거치고 있습니다. 저희는 팀을 더욱 확장하고, 개발
        및 운영 프로세스를 개선하고, 유저 피드백을 더 면밀히 살펴보며 더 나은
        바삭한소프트로 성장하기 위해 매일매일 노력하고 있습니다.
      </P>

      <P>
        비록 이 과정에서 기대에 미치지 못한 부분이 있었을 수 있으나, 더 좋은 게임을 만들고
        서비스하기 위한 시행착오에서 발생한 ‘성장의 과정’으로 여기고 꼭 더 발전하겠다는
        약속을 드리고 싶습니다.
      </P>

      <P>
        이 글은 늘 저희를 응원해주시는 분들에게 저희 바삭한소프트의 다음 방향성에 대해
        공유하고자 작성되었습니다.
      </P>

      <GameSection game={GAMES.jobSeeker}>
        <P>먼저 저희 최신작인 취준생 키우기, 취키에 대해 말씀드리고자 합니다.</P>

        <P>
          취키는 수키와 비슷하면서도 취준이라는 다른 소재와 새로운 시스템들을 중심으로 한
          신작입니다. 수험생 키우기에 이어서 취준생 키우기에도 많은 관심을 가져주셔서
          진심으로 감사드리며, 저희도 이러한 관심에 부응하기 위해 현재 가장 많은 노력과
          자원을 취키에 쏟고 있습니다.
        </P>

        <P>
          비록 수키 이후 첫 후속작을 출시하고 서비스하는 과정에서 많은 시행착오가 있었으나,
          저희는 이를 교훈삼아 유저분들의 의견에 더욱 귀기울이고 어떻게 해야 더 재밌는
          취키가 될 수 있을지 끊임없이 고민하며 개발을 이어가고 있습니다.
        </P>

        <P>이에 2026년 남은 기간 아래와 같은 내용의 주요 업데이트를 목표로 하고 있습니다.</P>

        <Figure>
          <img
            src={`${IMG}/job-seeker-roadmap.png`}
            alt="취준생 키우기 업데이트 예정: 스토리 모드 신규 스테이지 추가, 신규 모드 추가, 취업 경쟁 모드 랭킹 개선, 신규 스터디원 및 취준생 추가, 각종 다양한 시즌 이벤트, 추천인 기능 추가"
          />
        </Figure>

        <H3>스토리 모드 신규 스테이지 추가</H3>
        <P>취준생 키우기에 새로운 스토리가 추가될 예정입니다!</P>
        <P>
          이번 스토리는 천하기업 세계관의 몇 년 뒤를 배경으로 하며, 이번에도 각 챕터마다
          새롭고 재미있는 기믹을 함께 준비하고 있습니다.
        </P>
        <P>
          챕터 단위로 나누어 순차적으로 업데이트할 예정이며, 한 챕터 한 챕터 최대한
          완성도를 높여 여러분들께 선보이고자 합니다.
        </P>
        <P>하루빨리 완성해서 흥미롭고 즐거운 이야기를 보여드리고 싶습니다.</P>
        <P>기다려주시는 분들께 감사드리며, 좋은 모습으로 찾아뵐 수 있도록 준비하겠습니다.</P>

        <H3>신규 모드 추가</H3>
        <P>
          취준생 키우기에서 더 다채롭고 다양한 즐거움을 느낄 수 있도록 취업 경쟁 모드,
          스토리 모드와는 별개로 완전히 새로운 모드를 준비하고 있습니다.
        </P>
        <P>
          신규 모드에 대해서는 가을 중 공개할 예정이며, 세부 일정은 별도로 공지하도록
          하겠습니다.
        </P>

        <H3>취업 경쟁 모드 랭킹 개선</H3>
        <P>
          현재 취업 경쟁 모드에 여러 아쉬운 점이 있다는 것을 저희도 인지하고 있습니다.
        </P>
        <P>
          이번 9월 내에 있을 업데이트를 시작으로 취업 경쟁 모드를 지속적으로 개선하고자
          합니다.
        </P>
        <P>
          취준생 여러분들이 더 도파민 터지는 재미를 느끼실 수 있게끔 취업 경쟁 모드에
          대해서는 끊임없이 개선과 분석을 거듭하고 있습니다. 이에 대해선 방향이 정해지는
          대로 별도의 소식으로 더 자세히 말씀드리겠습니다.
        </P>

        <H3>신규 스터디원 및 취준생 추가</H3>
        <P>
          9월 업데이트 예정인 "한시연" 스터디원을 시작으로 앞으로 꾸준히 새로운 스터디원과
          취준생을 선보일 계획입니다.
        </P>
        <P>
          각 캐릭터들은 여러분의 취준에 여러 즐거움을 더할 수 있도록 고유한 매력과 개성을
          살려 준비하고 있습니다.
        </P>
        <P>
          아직 스터디원이나 취준생으로 만나보지 못하셨던 기존 스토리 모드의 등장인물들도
          차례로 출시할 예정이며, 새롭게 추가되는 스토리 모드의 캐릭터들 역시 스터디원으로
          만나보실 수 있도록 준비하고 있습니다.
        </P>
        <P>
          새 취준생의 경우 10월 박현호 시즌 패스에 이어 11월 패스 소식과 함께 공개할
          예정입니다.
        </P>

        <H3>각종 시즌 이벤트</H3>
        <P>
          이번 추석 이벤트를 시작으로 풍성한 보상과 즐길거리가 가득한 시즌 이벤트를
          꾸준히 이어갈 예정입니다.
        </P>
        <P>
          다채로운 이벤트로 취준생분들께 다양한 재미를 전해드릴 수 있도록 노력하겠습니다.
        </P>

        <H3>추천인 기능 추가</H3>
        <P>많은 요청이 있었던 추천인 기능 역시 개발을 준비하고 있습니다.</P>
        <P>
          취준생 여러분께서 추가를 기다리시는 요소인 만큼 팀원들이 최선을 다해 기획과
          개발을 진행 중입니다.
        </P>

        <H3>기타 계획</H3>
        <P>
          저희 바삭한소프트는 취준생 키우기 또한 수험생 키우기와 같이 오래 사랑받는 게임이
          되길 바라며, 이를 위해 항상 노력하고 있다는 점을 꼭 말씀드리고 싶습니다.
        </P>
        <P>
          늘 응원을 보내주시는 모든 분들께 감사드리며, 앞으로 계속 발전하는 모습을 통해 팬
          여러분들의 기대에 부응하도록 하겠습니다.
        </P>
      </GameSection>

      <GameSection game={GAMES.studentMaker}>
        <P>
          수키는 많은 분들의 사랑을 받고 있으며, 저희도 큰 애정을 갖고 있는 바삭한소프트의
          대표작입니다. 하지만 상술했던 재투자 및 성장의 과정에서 수키에 더 많은 신경을
          쓰지 못했다는 점에 대해 저희도 항상 아쉬움을 느끼고 있습니다.
        </P>

        <P>
          수키는 저희 바삭한소프트의 근간이 되는 게임인 만큼, 저희는 계속해서 수키를 통해
          더 많은 수험생 여러분들께 다양한 재미를 전달하고 싶습니다. 이에 팀을 확장하고 더욱
          많은 노력을 쏟으며 수키의 새로운 업데이트를 준비하고 있습니다.
        </P>

        <P>
          이제 어느 정도 업데이트 내용이 윤곽이 잡혔기 때문에 드디어 수험생분들께도 저희가
          새로 준비중인 수키의 다음 업데이트 내용에 대해 공유드리고자 합니다.
        </P>

        <Figure>
          <img
            src={`${IMG}/student-maker-roadmap.png`}
            alt="수험생 키우기 업데이트 예정: 신규 확장팩, 이야기 팩 추가, 추석 이벤트, 3주년 이벤트"
          />
        </Figure>

        <H3>신규 확장팩</H3>
        <P>
          먼저 수험생 키우기를 사랑해주시는 분들께 새로운 확장팩이 출시될 거라는 기쁜
          소식을 전해드리고 싶습니다.
        </P>
        <P>
          출시 일정에 변동이 생길 수는 있지만, 이번 겨울 출시를 목표로 작업을 진행하고
          있습니다.
        </P>
        <P>
          이번 확장팩은 거의 3년 전부터 꾸준히 만들고 싶다고 생각해왔던 내용으로, 90년대
          초반 대한민국의 기념비적인 첫 수능을 주제로 하는 30일 정도의 스토리를 담고
          있습니다.
        </P>
        <P>본 확장팩에 대해서는 추후 상세한 정보를 공개하도록 하겠습니다.</P>

        <H3>이야기팩 추가</H3>
        <P>
          이번 여름 수키에 대한 사랑이 넘치는 여러 재능있는 스토리 기획자분들이 새로
          바삭한소프트에 합류하였고, 함께 수험생 키우기의 신규 이야기팩들을 제작했습니다.
        </P>
        <P>
          긴 시간 수험생 키우기의 업데이트를 기다려주신 수험생 여러분들에 대한 감사를
          전하기 위해 신규 이야기팩들은 가까운 시기에 한정 기간동안 무료로 공개될
          예정입니다.
        </P>

        <H3>이벤트 계획</H3>
        <P>
          9월에는 추석 이벤트가 진행될 예정이며, 11월에는 3주년 이벤트가 진행될 예정입니다.
        </P>
        <P>각 이벤트에 대한 자세한 내용은 추후 공지로 안내드릴 예정입니다.</P>

        <H3>팀원 모집</H3>
        <P>
          바삭한소프트의 수많은 게이머 분들께서 저희에게 주신 관심과 애정에 보답하기 위해
          수험생 키우기에 재밌는 신규 스토리를 같이 만들어나갈 열정있는 작가분들을 상시
          모집하고 있습니다.
        </P>
        <P>
          이 또한 바삭한소프트의 유저 여러분께서 많은 응원을 해 주신 결과이자 저희가 이에
          보답하기 위한 재투자의 일환이라고 말씀드리고 싶습니다.
        </P>

        <H3>기타 계획</H3>
        <P>
          올해로 출시 3주년을 맞고 있는 수험생키우기는 바삭한소프트가 많은 사랑을 받을 수
          있게 해준 첫 작품입니다.
        </P>
        <P>
          팀원들이 대학생 시절 뭉쳐서 만든 게임이 이렇게 전 세계의 많은 유저분들께 큰
          사랑을 받을 수 있었던 것이 아직도 신기하고 기쁜 마음입니다.
        </P>
        <P>
          이 모든 게 가능한 것이 수험생키우기와 취준생키우기에 많은 애정을 가져주신
          유저분들의 성원 덕분에 가능했습니다.
        </P>
        <P>
          저희를 응원해주신 만큼 장기적으로 수험생 키우기와 그 세계를 어떻게 발전시키고,
          또 어떻게 유저분들께 더 재밌게 전달할지 항상 고민하겠습니다. 또한 계속해서 더
          재밌는 게임을 만드는 데에 투자하여 그 성원에 보답하도록 노력하겠습니다.
        </P>
      </GameSection>

      <GameSection game={GAMES.galaxy}>
        <Figure>
          <img src={`${IMG}/galaxy-splash.jpg`} alt="은하원정대 키 비주얼" />
        </Figure>

        <P>은하원정대는 우주 SF 세계관의 텍스트 기반의 모바일 게임입니다.</P>

        <P>당초 은하원정대, 줄여서 은정대는 출시를 목적으로 구상된 게임은 아니었습니다.</P>

        <P>
          은정대는 25년 팀 내에서 다양한 게임 메커니즘을 연구하던 도중 만들어진
          프로토타입인데요. 간단히 만들어진 프로토타입임에도 내부에서 재밌다고 호평이
          많았습니다.
        </P>

        <P>
          이에 저희는 수키와 취키에서 쌓아 온 전략 시뮬레이션 장르에 대한 노하우에 더해,
          바삭한의 기존작에서 없었던 신선한 주제인 우주 SF 배경으로 유저분들께 새로운
          재미를 전할 수 있겠다고 생각하여 은정대의 개발을 계속하게 되었습니다. 이후
          소규모의 열정적인 팀원분들께서 틈틈이 시간을 내어 게임을 조금씩 발전시켜 지금에
          이르렀습니다.
        </P>

        <P>
          그렇게 은정대는 개발이 계속되어 플레이엑스포와 비공개 1차 테스트를 통해 적지 않은
          유저분들께 그 모습을 보여드릴 수 있었는데요. 많은 테스터분들께서 열정적인
          피드백과 긍정적인 의견을 제출해 주셔서 저희도 기쁘게 개발을 이어갈 수
          있었습니다.
        </P>

        <Figure>
          <img src={`${IMG}/galaxy-screens.jpg`} alt="은하원정대 게임 플레이 스크린샷 일부" />
          <figcaption>은하원정대 게임 플레이 스크린샷 일부</figcaption>
        </Figure>

        <P>
          바삭한소프트의 여러 상황을 고려하여 신작보다는 기존작들에 더 많은 노력과 애정을
          쏟아주기 바라는 유저분들의 진심어린 조언 또한 항상 귀기울여 듣고 있습니다.
          저희에게 애정을 가지고 바삭한소프트의 성장을 위해 이러한 의견을 제시해주시는
          많은 분들께 진심으로 감사드리고 싶습니다.
        </P>

        <P>
          따라서 기존 바삭한소프트의 게임들은 본 프로젝트와 무관하게 항상 최고의 노력을
          다해 개발과 운영을 지속할 것임을 말씀드립니다.
        </P>

        <P>
          마지막으로 은하원정대의 출시일은 아직 미정이지만, 근시일 내에 테스트를 진행하여
          소수의 유저분들께 먼저 선을 보일 예정입니다.
        </P>
      </GameSection>

      <GameSection game={GAMES.yeonae}>
        <P>
          이미 소식을 접한 분들도 있겠지만, 저희 바삭한소프트에서 네이버웹툰의 유명 IP
          ‘연애혁명’을 주제로 한 신작을 개발하게 되었습니다.
        </P>

        <P>
          연애혁명은 바삭한소프트의 많은 팀원들도 학창시절 사랑했던 웹툰으로서, 이를
          배경으로 게임을 만들게 됐다는 소식을 접했을 때 기쁨을 금치 못했습니다.
        </P>

        <P>
          저희는 연애혁명 원작을 즐겁게 보셨을 원작 팬들부터 기존에 수험생 키우기와 취준생
          키우기를 즐기시던 바삭한소프트의 팬분들까지, 양쪽에게 사랑을 받을 수 있는 게임을
          만들기 위해 노력하고 있습니다.
        </P>

        <P>
          연애혁명 키우기는 내년 하반기 혹은 2028년 런칭을 목표로 하고 있으며(변동 가능),
          추후 개발 현황에 따라 소식을 업데이트 할 예정입니다.
        </P>
      </GameSection>

      <H2>바삭한소프트 뉴스레터를 구독해주세요.</H2>

      <P>
        본 사이트를 통해 저희는 바삭한소프트의 팬들께 꾸준히 저희의 상황을 알려드리고,
        소통을 이어나가고자 합니다.
      </P>

      <P>
        아래 연락처를 남겨주시면 바삭한소프트가 계속해서 더 좋은 게임들을 만들어나가는
        과정을 가까이서 지켜보실 수 있습니다.
      </P>

      <P>앞으로도 잘 부탁드리겠습니다!</P>
    </>
  );
}
